exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".numberInScores{font-size:28px;color:#0d6247}", ""]);

// exports
